// Forces dark mode for pages whose design only exists in dark, and restores the
// user's own preference on the way out.
//
// Client-side because LiveView navigation does not re-render the root layout, so
// a theme set server-side would still be applied on the next page.
//
// On exit, dark is only restored when the `:dark_theme` flag is enabled for the
// org; otherwise a stale preference would leave a flag-off user stuck in dark.
//
// The restore is deferred by a frame and cancelled if another forced-dark page
// mounts in the meantime. Navigating between two such pages tears the old view
// down before building the new one, so restoring synchronously would strip
// `data-theme`, let the browser paint one light frame, and only then go dark
// again — which is exactly the flash this hook exists to prevent.
const STORAGE_KEY = "theme";

let pendingRestore = null;

function cancelPendingRestore() {
  if (pendingRestore !== null) {
    cancelAnimationFrame(pendingRestore);
    pendingRestore = null;
  }
}

export const ForceDarkMode = {
  mounted() {
    cancelPendingRestore();
    document.documentElement.setAttribute("data-theme", "dark");
  },

  destroyed() {
    const flagEnabled = this.el.dataset.darkThemeEnabled === "true";

    cancelPendingRestore();
    pendingRestore = requestAnimationFrame(() => {
      pendingRestore = null;

      let saved;
      try {
        saved = localStorage.getItem(STORAGE_KEY);
      } catch {
        saved = null;
      }

      if (flagEnabled && saved === "dark") {
        document.documentElement.setAttribute("data-theme", "dark");
      } else {
        document.documentElement.removeAttribute("data-theme");
      }
    });
  },
};
